/**
 * Transfer restrictions.
 */

export const UNRESTRICTED = 'unrestricted'
export const RESTRICTED = 'restricted'
export const CUSTOM = 'custom'